<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h1>Gestión de Facultades</h1>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="openModal(null)">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nueva Facultad
          </b-button>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        responsive
        class="mt-2"
        :items="faculties"
        :fields="fields"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Cargando...</strong>
          </div>
        </template>

        <template #cell(estado)="data">
          <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
            {{ data.value ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button variant="gradient-primary" class="btn-icon" @click="openModal(data.item)">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon ml-1" @click="deleteFaculty(data.item)">
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <faculty-modal
      :faculty-data="selectedFaculty"
      @submit="handleModalSubmit"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge, BSpinner,
} from 'bootstrap-vue'
import FacultyModal from '@/components/faculties/FacultyModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import facultadesService from '@/services/facultadesService'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BSpinner,
    FacultyModal,
  },
  data() {
    return {
      fields: [
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'nombre', label: 'Nombre', sortable: true },
        { key: 'descripcion', label: 'Descripción', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      faculties: [],
      selectedFaculty: null,
      loading: false,
    }
  },
  async mounted() {
    await this.loadFaculties()
  },
  methods: {
    async loadFaculties() {
      this.loading = true
      try {
        const response = await facultadesService.getAll()
        this.faculties = response.data
      } catch (error) {
        console.error('Error al cargar facultades:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al cargar las facultades',
          },
        })
      } finally {
        this.loading = false
      }
    },
    openModal(item) {
      this.selectedFaculty = item ? { ...item } : null
      this.$bvModal.show('faculty-modal')
    },
    async handleModalSubmit(data) {
      try {
        if (data.facultadId) {
          // Actualizar
          await facultadesService.update(data.facultadId, {
            codigo: data.codigo,
            nombre: data.nombre,
            descripcion: data.descripcion,
            estado: data.estado,
          })
        } else {
          // Crear
          await facultadesService.create({
            codigo: data.codigo,
            nombre: data.nombre,
            descripcion: data.descripcion,
            estado: data.estado,
          })
        }
        
        await this.loadFaculties()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Operación Exitosa',
            icon: 'CheckIcon',
            variant: 'success',
            text: `La facultad se ha ${data.facultadId ? 'actualizado' : 'creado'} correctamente.`,
          },
        })
      } catch (error) {
        console.error('Error al guardar facultad:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al guardar la facultad',
          },
        })
      }
    },
    async deleteFaculty(item) {
      try {
        await this.$swal({
          title: '¿Estás seguro?',
          text: '¡No podrás revertir esto!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, ¡elimínala!',
          cancelButtonText: 'Cancelar',
          customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
          buttonsStyling: false,
        })

        await facultadesService.delete(item.facultadId)
        await this.loadFaculties()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Eliminada',
            icon: 'TrashIcon',
            variant: 'success',
            text: 'La facultad ha sido eliminada.',
          },
        })
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error al eliminar facultad:', error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: 'Error al eliminar la facultad',
            },
          })
        }
      }
    },
  },
}
</script>
